/**
 * Created by xinleaf on 2019/5/13.
 */

import Vue from 'vue'

Vue.filter('initOptions',function(data){
	console.log('filter-data:',data)
	return data.map(item=>{
		item.name = item.text
	})
})


// WEBPACK FOOTER //
// ./src/utils/filter.js